import type { SubscriptionItem } from '@cannect/services/resources/recurrency/types'
import { subscriptionsCopy } from '../copy'

const MAX_THUMBS = 3

export const ItemThumbs = ({ items }: { items: SubscriptionItem[] }) => {
  const visible = items.slice(0, MAX_THUMBS)
  const rest = items.length - visible.length

  return (
    <div className="flex items-center gap-2">
      {visible.map((item) =>
        item.image ? (
          <img
            key={item.productId}
            src={item.image}
            alt={item.name || 'Produto'}
            className="h-12 w-12 shrink-0 rounded-md border border-solid border-neutral-100 bg-white object-contain"
          />
        ) : (
          <span
            key={item.productId}
            role="img"
            aria-label={item.name || 'Produto'}
            className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md border border-solid border-neutral-100 bg-neutral-50 text-xs text-neutral-500">
            {(item.name || 'P').charAt(0)}
          </span>
        )
      )}
      {rest > 0 && (
        <span className="text-sm font-semibold text-neutral-600" aria-label={`e mais ${rest} produtos`}>
          {subscriptionsCopy.moreItems(rest)}
        </span>
      )}
    </div>
  )
}
